export const renderLabelRange = ({ label_range }) => {
    if (!label_range) {
        return ''
    }

    return `<p class="cb-range t-xs-500-sl">${label_range}</p>`
}
